import React from 'react';
import Login from './components/authorization/login/login';
import Registration from './components/authorization/registration/registration';
import ForgotPassword, {
  CheckEmail,
  PasswordReset
} from './components/authorization/forgot-password/forgot-password';
import {
  Route,
  PrivateRoute,
  AuthorizationRoute
} from './components/HOCs/route';
import BakerProfile from './components/baker-profile/baker-profile';
import Layout from './components/layout/layout';
import Home from './components/home/home';
import Categories from './components/categories/categories';
import Category from './components/category/category';
import AddProduct from './components/add-product';
import { Router } from '@reach/router';
import Product from './components/product/product';
import ManageProducts from './components/manage-products';
import EditProduct from './components/manage-products/edit-product';
import UserProfile from './components/user-profile/profile';
import VerificationCode from './components/authorization/registration/verification-code';
import NotFound from './components/common/not-found/not-found';
import Mailbox from './components/mailbox/mailbox';
import Favorites from './components/favorites';
import Chat from './components/chat/chat';
import SeenProducts from './components/seenProducts';
import SnackbarMessage from './components/snackbar/snackbar';

// https://github.com/reach/router/issues/242#issuecomment-491537468
export const ScrollToTop = (props: any) => {
  React.useEffect(() => window.scrollTo(0, 0), [props.location.pathname]);
  return props.children;
};

export const SnackBarContext = React.createContext({} as any);

class App extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      snackbar: {
        show: false,
        message: '',
        status: ''
      },
      openSnackBar: (status, message) => {
        this.setState({
          snackbar: {
            show: true,
            message,
            status
          }
        });
      }
    };
  }

  public render() {
    return (
      <div className="App" style={{ maxWidth: '600px', margin: 'auto' }}>
        <SnackBarContext.Provider value={this.state as any}>
          <SnackBarContext.Consumer>
            {({ snackbar }) => <SnackbarMessage snackbar={snackbar} />}
          </SnackBarContext.Consumer>
          <Router>
            <ScrollToTop path="/">
              <Route component={VerificationCode} path="/verify-email/:email" />
              <Route component={CheckEmail} path="/check-email/:email" />
              <Route
                component={PasswordReset}
                path="/password/reset/confirm/:token"
              />
              <Route component={Layout} path="/">
                <AuthorizationRoute component={Login} path="/login" />
                <AuthorizationRoute component={Registration} path="/signup" />
                <AuthorizationRoute
                  component={ForgotPassword}
                  path="/forgot-password"
                />
                <Route component={NotFound} path="/404" default />
                <Route component={Home} path="/" />
                <PrivateRoute component={AddProduct} path="/add-product" />
                <PrivateRoute component={UserProfile} path="/user-profile" />
                <PrivateRoute component={Mailbox} path="/mailbox" />
                <PrivateRoute component={Chat} path="/mailbox/:id" />
                <PrivateRoute component={SeenProducts} path="/seen-products" />
                <PrivateRoute component={Favorites} path="/favorites" />
                <Route component={Categories} path="/categories" />
                <Route component={BakerProfile} path="/baker/:baker" />
                <Route component={Category} path="/categories/:category" />
                <Route component={Product} path="/product/:product" />
                <PrivateRoute
                  component={ManageProducts}
                  path="/manage-products"
                />
                <PrivateRoute
                  component={EditProduct}
                  path="/edit-product/:id"
                />
              </Route>
            </ScrollToTop>
          </Router>
        </SnackBarContext.Provider>
      </div>
    );
  }
}

export default App;
